import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["name", "website", "email", "phone", "address", "accountNumber"];

  connect() {
    this.updateProfile();
    console.log('vendor-profile connected');
  }

  updateProfile() {
    const nameElement = document.querySelector('input[name="vendor[name]"]');
    const emailElement = document.querySelector('input[name="vendor[email]"]');
    const websiteElement = document.querySelector('input[name="vendor[website]"]');
    const phoneElement = document.querySelector('input[name="vendor[phone]"]');
    const addressElement = document.querySelector('textarea[name="vendor[address]"]');
    const accountNumberElement = document.querySelector('input[name="vendor[financial_details][account_number]"]');

    const name = nameElement ? nameElement.value : '';
    const email = emailElement ? emailElement.value : '';
    const website = websiteElement ? websiteElement.value : '';
    const phone = phoneElement ? phoneElement.value : '';
    const address = addressElement ? addressElement.value : '';
    const accountNumber = accountNumberElement ? accountNumberElement.value : '';

    if (website) {
      this.nameTarget.innerHTML = `<a href="${website}" target="_blank"><i class="fa fa-globe"></i> ${name}</a>`;
    } else {
      this.nameTarget.textContent = name;
    }

    this.emailTarget.innerHTML = email ? `<a href="mailto:${email}" target="_blank"><i class="fa fa-envelope"></i> ${email}</a>` : '';
    this.phoneTarget.innerHTML = phone ? `<a href="tel:${phone}" target="_blank"><i class="fa fa-phone"></i> ${phone}</a>` : '';
    this.addressTarget.textContent = address;
    this.accountNumberTarget.innerHTML = accountNumber ? `Acc. Number:<br>${accountNumber}` : '';
  }
}
